/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    faqWrapper: {
      padding: 8,
    },
    faqQuestion: {
      color: colors.primaryExtraLight,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      marginBottom: globalScale * 8,
    },
    paragraph: { // @TODO: really should be getting from Help/styles.native.js `qqq:keep` so that the script doesn't delete this
      fontSize: globalScale * 16,
      marginBottom: globalScale * 8,
      color: colors.white,
      flexGrow: 1,
    },
  };
};

export default getStyles;
